module.exports = __webpack_public_path__ + "img/Katarina_acc_05.8364e644.jpg";